<script setup lang="ts">
// https://github.com/vueuse/head
// you can use this to manipulate the document head in any components,
// they will be rendered correctly in the html results with vite-ssg
useHead({
  title: 'Ari10 ATM Dashboard',
  meta: [
    {
      name: 'description',
      content: 'Manage your Bitcoin ATMs... easily.',
    },
    {
      name: 'theme-color',
      content: () => isDark.value ? '#00aba9' : '#ffffff',
    },
  ],
  link: [
    {
      rel: 'icon',
      type: 'image/svg+xml',
      href: () => preferredDark.value ? 'https://ari10.com/ari-favicon.svg' : 'https://ari10.com/ari-favicon.svg',
    },
  ],
})
</script>

<template>
  <RouterView />
</template>

<style lang="scss">
@use 'scss/main.scss';
#app {
  font-family: 'Inter', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  margin: 0;
  min-width: 20rem;
}
</style>
